module.exports = __webpack_public_path__ + "img/athletic-bilbao.7f294f44.png";